/**
 * anonym Users
 */

require('./common');

//const files = require.context('./components', true, /\LoadMore.vue$|AddComment.vue$|AutoIt.vue$|ThumbsUp.vue$/i);
/*import { Vue } from "vue";
Vue.prototype.messages = window.messages;
const files = require.context('./components', true, /\LoadMore.vue$|AddComment.vue$|AutoIt.vue$|ThumbsUp.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

let elements = document.getElementsByClassName('app')
for(let el of elements){
	new Vue({
  	el:el
  })
}
*/

import { createApp } from 'vue';
import LoadMore from './components/LoadMore.vue';
import AddComment from './components/AddComment.vue';
import ThumbsUp from './components/ThumbsUp.vue';

//const app = createApp({});
//app.component('load-more', LoadMore);
//window.Vue.prototype.messages = window.messages;
//window.messages = messages
let elements = document.getElementsByClassName('app')
for(let el of elements){
    const app = createApp({});
	app.component('load-more', LoadMore);
	app.component('add-comment', AddComment);
	app.component('thumbs-up', ThumbsUp);
    app.mount(el);
}
